import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {Mensaje} from "../../../../../chacra-core";

export {Mensaje} from "../../../../../chacra-core";


export const mensajesAdapter: EntityAdapter<Mensaje> = createEntityAdapter<Mensaje>({
  selectId: model => model.mensajeId
});

export interface MensajesState extends EntityState<Mensaje> {
  isLoading?: boolean;
  error?: string | null;
}

export const initialState: MensajesState = mensajesAdapter.getInitialState(
  {
    isLoading: false,
    error: null
  }
);
